// extracted by mini-css-extract-plugin
export default {"industryModel":"styles_industryModel__2gLYu","boxModel":"styles_boxModel__HZmY+","cross":"styles_cross__W8Jyr"};